import React, { createContext, useState, useContext } from "react";

export const CurrencyContext = createContext({
  currency: "AED",
  setCurrency: (c: string) => {},
});

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currency, setCurrency] = useState("AED");
  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
